import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Masked line-by-line reveal: each line sits in an overflow-hidden mask and
 * translates up from below on mount. Used for the signature hero moment.
 */
export default function MaskedText({ lines = [], className = "", lineClass = "", delay = 0.15 }) {
  const reduce = useReducedMotion();

  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          {reduce ? (
            <span className={lineClass}>{line}</span>
          ) : (
            <motion.span
              className={`${lineClass} block`}
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{
                duration: 0.95,
                delay: delay + i * 0.13,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              {line}
            </motion.span>
          )}
        </span>
      ))}
    </span>
  );
}
